import { NotificationsRounded } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { useState } from "react";

const WelcomeCard = ({ name }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="dash-card side-by-side" id="welcome-card">
      <div className="full-space">
        <h4 className="gradient-text-title mb-0">Hello, {name || "Guest"}!</h4>
        <p className="mb-0 subtitle">Stay focused and keep studying!</p>
      </div>
      <div>
        <IconButton
          fontSize="small"
          onClick={() => setOpen(!open)}
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
          disableRipple
        >
          <Tooltip title="Coming Soon" open={open}>
            <NotificationsRounded color="iconGray" fontSize="large" />
          </Tooltip>
        </IconButton>
      </div>
    </div>
  );
};

export default WelcomeCard;
